import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import "../sass/style.scss";

import Topbar from "../components/layout/topbar";
import Sidebar from "../components/layout/sidebar";
import Footer from "../components/layout/footer";
import Dashboard from "../components/layout/dashboard";
import ContextMenu from "../components/context";
import Modal from "../components/modal";
import Propostas from "../views/admin/propostas";
import Pessoas from "../views/admin/pessoas";
import { contextMenuOptions } from "../helpers/general";
import { uriList } from "../helpers/config";
import { bancoFornecedor, sendData } from "../helpers/auth";
import Convenios from "../views/admin/convenios";
import Empresas from "../views/admin/empresas";
import Emails from "../views/admin/emails";
import Tabelas from "../views/admin/tabelas";
import Coeficientes from "../views/admin/coeficientes";
import Configuracoes from "../views/admin/configuracoes";
import Pendencias from "../views/admin/pendencias";
import Retencoes from "../views/admin/retencoes";
import Reapresentacoes from "../views/admin/reapresentacoes";
import Solicitacoes from "../views/admin/solicitacoes";
import NovaProposta from "./propostaAgente";
import NovaPropostaCef from './propostaCef';
import CreditoPessoal from "./creditoPessoal";
import Usuarios from "../views/admin/usuarios";
import Refinanciamento from "./refinanciamento";
import Portabilidade from "./portabilidade";
import Cartao from "./cartao";
import Fgts from "./fgts";
import CreditoTrabalhador from "./creditoTrabalhador";
import AutorizacaoCreditoTrabalhador from "./autorizacaoCreditoTrabalhador";
import CalculadoraMargem from "./calculadoraMargem";
import AutorizacaoINSS from "./autorizacaoINSS";
import Documentos from "../views/admin/documentos";
import AutorizacaoSicoob from "./autorizacaoSicoob";
import { connect } from "react-redux";
import { setUser, setPendencias } from "./../store/actions/dados";
import Checkpoints from "../components/form/admin/Conformidade/Checkpoints";
import Checklists from "../components/form/admin/Conformidade/Checklists";
import PreencherChecklist from "../components/form/admin/Conformidade/PreencherChecklist";
import Portabilidades from "../views/admin/portabilidades";
import Charts from "../views/admin/Dashboard/charts";
import GruposPermissoes from "../views/admin/grupos_permissoes";
import { checarPermissao } from "../helpers/acls";

const defaultContext = {
  display: {
    up: false,
  },
  options: "",
};

const SEM_PERMISSAO = {
  title: "Sem permissão",
  content: "Usuário sem permissão para acessar esta página"
};

const ROLES_ADMIN = ["ADMINISTRADOR"];

const ROUTES = {
  "/admin": {
    recurso: "adminPropostas",
    title: "Fila de Propostas",
    content: (props, toggleContextMenu, checklist, action) => (
      <Propostas context={toggleContextMenu} checklist={checklist} action={action} />
    ),
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  // "/admin/esteira/portabilidade": {
  //   recurso: "adminPortabilidade",
  //   title: "Esteira - Portabilidade",
  //   content: (props, toggleContextMenu, checklist, action) => (
  //     <Portabilidades context={toggleContextMenu} checklist={checklist} action={action} operacao={"PORTABILIDADE"} />
  //   ),
  //   roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  // },
  // "/admin/esteira/novo": {
  //   recurso: "adminContratoNovo",
  //   title: "Esteira - Contrato Novo",
  //   content: (props, toggleContextMenu, checklist, action) => (
  //     <Portabilidades context={toggleContextMenu} checklist={checklist} action={action} operacao={"CONTRATO NOVO"} />
  //   ),
  //   roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  // },
  // "/admin/esteira/refinanciamento": {
  //   recurso: "adminRefinanciamento",
  //   title: "Esteira - Refinanciamento",
  //   content: (props, toggleContextMenu, checklist, action) => (
  //     <Portabilidades context={toggleContextMenu} checklist={checklist} action={action} operacao={"REFINANCIAMENTO"} />
  //   ),
  //   roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  // },
  "/admin/pessoas": {
    recurso: "adminPessoas",
    title: "Pessoas",
    content: () => <Pessoas />,
    roles: ["ADMINISTRADOR", "OPERADOR"]
  },
  "/admin/dashboard": {
    recurso: "adminDashboard",
    title: "Dashboard",
    content: () => <Charts />
  },
  "/admin/convenios": {
    recurso: "adminConvenios",
    title: "Convênios",
    content: () => <Convenios />
  },
  "/admin/novaProposta": {
    recurso: "adminContratoNovo",
    title: "Nova Proposta",
    content: (bancoFornecedor() == "cef") ? (<NovaPropostaCef novaProposta={true} />) : (<NovaProposta novaProposta={true} />),
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/creditoPessoal": {
    recurso: "adminCreditoPessoal",
    title: "Consignado CLT",
    content: () => <CreditoPessoal novaProposta={true} />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/Refinanciamento": {
    recurso: "adminRefinanciamento",
    title: "Refinanciamento",
    content: () => <Refinanciamento />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/Portabilidade": {
    recurso: "adminPortabilidade",
    title: "Portabilidade",
    content: () => <Portabilidade />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/Cartao": {
    recurso: "adminCartao",
    title: "Cartão",
    content: () => <Cartao />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/calculadoraMargem": {
    recurso: "adminCalculadoraMargem",
    title: "Calculadora de Margem",
    content: () => <CalculadoraMargem />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/autorizacaoINSS": {
    recurso: "adminAutorizacaoINSS",
    title: "Autorização Inss",
    content: () => <AutorizacaoINSS />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/documentos": {
    recurso: "adminDocumentos",
    title: "Documentos Gerais",
    content: () => <Documentos />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  // "/admin/autorizacaoSicoob": {
  //   recurso: "adminAutorizacaoSicoob",
  //   title: "Autorização Sicoob",
  //   content: () => <AutorizacaoSicoob />
  // },
  "/admin/Fgts": {
    recurso: "adminFgts",
    title: "FGTS",
    content: () => <Fgts />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/CreditoTrabalhador": {
    recurso: "adminCreditoTrabalhador",
    title: "Crédito Trabalhador",
    content: () => <CreditoTrabalhador />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/autorizacaoCreditoTrabalhador": {
    recurso: "adminAutorizacaoCreditoTrabalhador",
    title: "Autorização Crédito Trabalhador",
    content: () => <AutorizacaoCreditoTrabalhador />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/configuracoes": {
    recurso: "adminConfiguracoes",
    title: "Configurações",
    content: () => <Configuracoes />
  },
  "/admin/pendencias": {
    recurso: "adminPendencias",
    title: "Pendências",
    content: () => <Pendencias />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/retencoes": {
    recurso: "adminRetencoes",
    title: "Retenções",
    content: () => <Retencoes />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/reapresentacoes": {
    recurso: "adminReapresentacoes",
    title: "Reapresentação de TED",
    content: () => <Reapresentacoes />,
    roles: ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]
  },
  "/admin/solicitacoes": {
    recurso: "adminSolicitacoes",
    title: "Solicitações",
    content: () => <Solicitacoes />
  },
  "/admin/emails": {
    recurso: "adminEmails",
    title: "Emails",
    content: () => <Emails />
  },
  "/admin/tabelas": {
    recurso: "adminTabelas",
    title: "Tabelas",
    content: () => <Tabelas />
  },
  "/admin/coeficientes": {
    recurso: "adminCoeficientes",
    title: "Coeficientes",
    content: () => <Coeficientes />
  },
  // "/admin/checkpoint": {
  //   recurso: "adminCheckpoints",
  //   title: "CheckPoints",
  //   content: () => <Checkpoints />
  // },
  // "/admin/preencherChecklist": {
  //   recurso: "admin_preencher_checklist",
  //   title: "Preencher Checklist",
  //   content: () => <PreencherChecklist />
  // },
  // "/admin/checklist": {
  //   recurso: "adminChecklists",
  //   title: "CheckLists",
  //   content: () => <Checklists />
  // },
  "/admin/usuarios": {
    recurso: "adminUsuarios",
    title: "Usuários",
    content: () => <Usuarios />
  },
  "/admin/grupos_permissoes": {
    recurso: "adminGruposPermissoes",
    title: "Grupos de Permissões",
    content: () => <GruposPermissoes />
  },
  "/admin/empresas": {
    recurso: "adminEmpresas",
    title: "Empresas",
    content: () => <Empresas />
  }
};

function Admin(props) {
  const path = window?.location?.pathname;

  const [contextMenu, setContextMenu] = useState(false);
  const [modal, setModal] = useState(false);
  const [detailedModal, setDetailedModal] = useState({
    title: "",
    text: [],
  });
  const [action, setAction] = useState("");
  const [checklist, setChecklist] = useState(false);

  async function toggleMenuOptions(_proposta) {
    const multSelect = _proposta?.multSelect?.length > 1
    console.log("admin.toggleMenuOptions(1)", { multSelect });
    let result = [...contextMenuOptions].map((item, index) => ({
      ...item,
      originalIndex: index // Adiciona o índice original de cada item
    })).sort((a, b) => {
      // Obtém os valores de order, tratando tanto campo quanto função
      const getOrder = (item) => {
        if (typeof item.order === 'function') {
          return item.order({ ..._proposta, user: props.user });
        }
        return item.order !== undefined ? item.order : Infinity;
      };

      const orderA = getOrder(a);
      const orderB = getOrder(b);

      // Se as ordens forem diferentes, ordena por order
      if (orderA !== orderB) {
        return orderA - orderB;
      }

      // Se as ordens forem iguais, mantém a ordem original no array
      return a.originalIndex - b.originalIndex;
    }).map(item => {
      // Remove o campo originalIndex após a ordenação
      const { originalIndex, ...rest } = item;
      return rest;
    });

    let posicao, antifraude;
    if (_proposta) {
      posicao = _proposta.posicao.toLowerCase();
      antifraude = _proposta.antifraude;
    }

    result.map((option, i) => {
      if (multSelect && option.multSelect) {
        option.enabled = !option.enableFunction || option?.enableFunction({ ..._proposta, user: props.user }, option.enabled, props.filtrosPropostas);
      }
      else {
        option.enabled =
          props.user &&
          (!option.positions || option.positions.indexOf(posicao) >= 0) &&
          (!option.positionsEx || option.positionsEx.indexOf(posicao) < 0) &&
          (option.action != "antifraude" || !antifraude);

        if (option.enableFunction)
          option.enabled = option.enableFunction({ ..._proposta, user: props.user }, option.enabled, props.filtrosPropostas);
      }
    });

    return result;
  }

  async function toggleContextMenu(e, display, proposta) {
    let x = e.pageX || 0;
    let y = e.pageY || 0;

    let _mult = 25;
    if (proposta?.multSelect?.length > 1)
      _mult = 12

    let _contextMenuOptions;
    if (display) _contextMenuOptions = await toggleMenuOptions(proposta);

    const posY = () => {
      let _const = _contextMenuOptions.filter((el) => el.enabled).length * _mult;
      let contextBottom = y + _const;
      let windowBottom = window.innerHeight + window.pageYOffset;

      if (contextBottom >= windowBottom) {
        y = y - _const;
      }

      return y;
    };

    const posX = () => {
      const _const = 160;
      let contextRight = x + _const;

      if (contextRight > window.innerWidth) {
        x = x - _const;
      }

      return x;
    };

    if (y && display) {
      y = posY();
    }

    if (x && display) {
      x = posX();
    }

    setContextMenu({
      display: {
        up: display,
        x,
        y,
      },
      options: _contextMenuOptions,
    });
  }

  // Nova função para checar permissão da rota atual
  function getRouteInfo(path, props) {
    const route = ROUTES[path];
    if (!route) {
      return { title: "404", content: "Página não existe" };
    }
    const { recurso, title, content, roles } = route;
    const _roles = roles || ROLES_ADMIN;
    if (!checarPermissao(props.user, recurso, _roles, props.permissoes)) {
      return SEM_PERMISSAO;
    }
    // content pode ser função ou componente
    return {
      title,
      content: typeof content === "function"
        ? content(props, toggleContextMenu, checklist, action)
        : content
    };
  }

  useEffect(() => {
    if (contextMenu) {
      let action = localStorage.getItem("action");
      setAction(action);
      localStorage.removeItem("action");

      let _checklist = localStorage.getItem("checklist");
      setChecklist(_checklist);
      localStorage.removeItem("checklist");
    }
  }, [contextMenu]);

  const routeInfo = getRouteInfo(path, props);

  return (
    <>
      <main
        onClickCapture={(e) => toggleContextMenu(defaultContext, false)}
        id="wrapper"
      >
        <Topbar />
        <Sidebar phone={process.env.REACT_APP_WHATS} />
        <div className="content-page">
          <div
            style={{
              backgroundColor: "#f7f7f2",
              minHeight: window.innerHeight + "px",
            }}
            className="content"
          >
            <div className="page-content-wrapper">
              <div className="container-fluid">
                <Dashboard title={routeInfo.title} />
                {routeInfo.content}
                <ContextMenu
                  display={contextMenu.display}
                  options={contextMenu.options}
                />
              </div>
            </div>
          </div>
          <Footer />
        </div>
        {modal && (
          <Modal
            title={detailedModal.title}
            text={detailedModal.text}
            page={detailedModal.page}
            onClick={() => setModal(false)}
          />
        )}
      </main>
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: state.dados.user,
    proposta: state.dados.proposta,
    detalhes: state.dados.detalhes,
    pendencias: state.dados.pendencias,
    filtrosPropostas: state.dados.filtrosPropostas,
    permissoes: state.dados.permissoes,
  };
}

export default withRouter(connect(mapStateToProps)(Admin));
